import React, { useEffect, useState } from 'react';
import moment from 'moment';
import DataTable from 'react-data-table-component';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import AnnouncementService from '../Services/Announcement.service'
import Swal from 'sweetalert2'

function News() {
    const announcementService = new AnnouncementService()
    const [_id , set_ID] = useState(null);
    const [subject , setSubject] = useState('');
    const [content , setContent] = useState('');
    const [status , setStatus] = useState(0);
    const [announce , setAnnounce] = useState([{an_id:1,an_active:1,an_date:'2022-08-18 00:00:00',an_subject:'เพิ่มสินค้าใหม่ (หวยหุ้นดาวโจนส์พิเศษ) เพิ่มสินค้าใหม่ (หวยหุ้นดาวโจนส์พิเศษ)'}]);
    
    useEffect(()=>{
        // console.log(subject,content);
        fetchAnnoucement()
    },[])

    useEffect(()=>{
        console.log(_id);
    },[_id])

    const fetchAnnoucement = ()=>{
        announcementService.listing().then((result)=>{
            // console.log(result)
            setAnnounce(result)
        })
    }

    const getAnnoucement = (e)=>{
        set_ID(e.an_id)
        setSubject(e.an_subject)
        setContent(e.an_message)
        setStatus(e.an_active)
    }

    const formSubmit = (e) => {
        // e.preventDefault()
        if(!_id){
            announcementService.add({"subject": subject, "message": content, "active": status }).then((result)=>{
                if (result.success){
                    fetchAnnoucement()
                    Swal.fire({
                        title: result.message,
                        text:'',
                        icon: 'success',
                        confirmButtonText: 'ตกลง',
                        confirmButtonColor: 'green',
                    })
                }else{
                    Swal.fire({
                        title: result.message,
                        text:'',
                        icon: 'warning',
                        confirmButtonText: 'ตกลง',
                        confirmButtonColor: '#890000',
                      })
                }
            })
        }else{
            announcementService.update({ "id": _id ,"subject": subject, "message": content, "active": status }).then((result)=>{
                if (result.success){
                    fetchAnnoucement()
                    Swal.fire({
                        title: result.message,
                        text:'',
                        icon: 'success',
                        confirmButtonText: 'ตกลง',
                        confirmButtonColor: 'green',
                    })
                }else{
                    Swal.fire({
                        title: result.message,
                        text:'',
                        icon: 'warning',
                        confirmButtonText: 'ตกลง',
                        confirmButtonColor: '#890000',
                      })
                }
            })
        }
        console.log(_id,subject,content);
    }

    const delAnnoucement = (an_id) => {
        
        Swal.fire({
            title: 'ยืนยัน',
            text: 'คุณต้องการลบรายการประกาศข่าวสารนี้หรือไม่',
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'ยืนยัน',
            confirmButtonColor:'#890000',
            cancelButtonText: 'ยกเลิก',
          }).then((result) => {
            if (result.isConfirmed) {
                announcementService.del({ "id": an_id }).then((result)=>{
                    console.log(result.success)
                    if (result.success){
                        fetchAnnoucement()
                        Swal.fire({
                            title: result.message,
                            text:'',
                            icon: 'success',
                            confirmButtonText: 'ตกลง',
                            confirmButtonColor: 'green',
                        })
                    }else{
                        Swal.fire({
                            title: result.message,
                            text:'',
                            icon: 'warning',
                            confirmButtonText: 'ตกลง',
                            confirmButtonColor: '#890000',
                        })
                    }
                })
            }
        });
    }

    const clearForm = (e) => {
        // e.preventDefault()
        set_ID(null);
        setSubject('')
        setContent('')
        setStatus(0)
    }
  return (
    <div className="container pt-3">
        <h4>ประกาศข่าวสาร</h4>
        <hr/>
        <div className="row">
            <div className="col-lg-5 col-sm-5 col-sm-5 col-12">
                <div className="card">
                    <div className="card-body">
                        <div className="mb-3">
                            <label  className="form-label">หัวข้อประกาศ</label>
                            <input type="text" className="form-control form-control-sm" maxLength={100} value={subject} id="" placeholder="ประกาศข่าวสาร" onChange={(e)=>setSubject(e.target.value)}/>
                        </div>
                        <div className="mb-3">
                            <label  className="form-label">เนื้อหาประกาศ</label>
                            <CKEditor
                                editor={ ClassicEditor }
                                data={content}
                                config={{         
                                    toolbar: ['heading', '|', 'alignment', 'bold', 'italic', 'blockQuote', 'link', 'numberedList', 'bulletedList',"|", 'insertTable',
                                    'tableColumn', 'tableRow', 'mergeTableCells', '|', 'undo', 'redo']
                                  }}
                                onReady={ editor => {
                                    // You can store the "editor" and use when it is needed.
                                    // console.log( 'Editor is ready to use!', editor );
                                } }
                                onChange={ ( event, editor ) => {
                                    const data = editor.getData();
                                    // console.log( { event, editor, data } );
                                    setContent(data);
                                } }
                                onBlur={ ( event, editor ) => {
                                    // console.log( 'Blur.', editor );
                                } }
                                onFocus={ ( event, editor ) => {
                                    // console.log( 'Focus.', editor );
                                } }
                            />
                        </div>
                        <div className="mb-2 text-center">
                            <div className="mb-1">
                                <label className="form-label">ปิดปรับปรุงระบบ</label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="system_status" id="system_status" checked={status===1?true:false} onChange={(e)=>{setStatus(status===1?0:1)}} />
                                <label className="form-check-label">เปิดใช้งาน</label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="system_status" id="system_status" checked={status===0?true:false} onChange={(e)=>{setStatus(status===0?1:0)}}/>
                                <label className="form-check-label">ปิดใช้งาน</label>
                            </div>
                        </div>
                        <div className="mb-3">
                            <button className="btn btn-sm btn-secondary me-2" onClick={clearForm}>ล้างฟอร์มข้อมูล</button>
                            <button className="btn btn-sm btn-warning float-end" onClick={formSubmit}>บันทึกข้อมูล</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-lg-7 col-sm-7 col-sm-7 col-12 mt-2">
                <div className="card">
                    <div className="card-body table-responsive">
                    <DataTable
                            pagination
                            columns={[
                                    {
                                        name: 'วัน-เวลา',
                                        width:'200px',
                                        selector: row => moment(row.an_date).format('DD/MM/YYYY HH:mm'),
                                    },
                                    {
                                        name: 'หัวข้อประกาศ',
                                        minWidth:'250px',
                                        maxWidth:'350px',
                                        selector: row => <p className="text-break"> {row.an_subject} </p>,
                                    },
                                    {
                                        name: 'สถานะ',
                                        minWidth:'75px',
                                        selector: row =>{
                                            return (row.an_active?<span className="badge rounded-pill bg-success">เปิดใช้งาน</span>:<span className="badge rounded-pill bg-danger">ปิดใช้งาน</span>) 
                                        } ,
                                    },
                                    {
                                        name: '',
                                        minWidth:'150px',
                                        right:true,
                                        selector: row => {
                                            return (
                                                <>
                                                    <button className="btn btn-sm btn-warning me-1" onClick={(e)=>{getAnnoucement(row)}}>แก้ไข</button>
                                                    <button className="btn btn-sm btn-danger " onClick={(e)=>{delAnnoucement(row.an_id)}}>ลบ</button>
                                                </>
                                            )
                                        },
                                    },
                                ]}
                            data={announce}
                            noDataComponent="ไม่พบรายการข้อมูล"
                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default News